// extracted by mini-css-extract-plugin
export var pageNavigation = "styles-module--pageNavigation--CTlHO";
export var link = "styles-module--link--7v-ac";